@for (row of rows(); track row.side) {
  <button
    type="button"
    class="chiron-stat"
    [class.is-design]="row.side === 'design'"
    [title]="row.tooltip"
    [attr.data-test-id]="'chiron-stat-' + row.side"
    (click)="onClick(row.side, $event)"
  >
    <span class="chiron-stat__label">
      <span class="chiron-stat__glyph" aria-hidden="true">{{ glyph }}</span>
      <b>{{ name() }}</b>
      <span class="chiron-stat__side">{{ row.sideLetter }}</span>
    </span>
    <span class="chiron-stat__position">{{ row.position }}</span>
  </button>
}
